import { toast } from 'react-toastify';


export const showToast = (toastType, title, message) => {
  const content = title ? <div><strong>{title}</strong><div>{message}</div></div> : message;

  const options = {
    position: "bottom-right",
    autoClose: 5000,
    closeButton: true,
    hideProgressBar: false,
    pauseOnHover: true,
    draggable: true,
    newestOnTop: true,
  };

  switch (toastType) {
    case "info":
      toast.info(content, options);
      break;
    case "warning":
      toast.warning(content, options);
      break;
    case "error":
      toast.error(content, options);
      break;
    default:
      toast.success(content, options);
      break;
  }
};